<script>
import { partner } from "@local/store/theme"
const partnerName = $partner.name || ""
</script>

<div class="min-h-screen bg-black text-white antialiased">
  <main
    class="mx-auto flex min-h-screen w-full max-w-6xl flex-col
           items-center px-5 pb-12 pt-8 text-center sm:px-8 sm:pt-10"
  >
    <!-- Logo -->
    <div class="flex justify-center">
      <img
        src="/images/hellomd/logo-dark.svg"
        alt="HelloMD"
        width="320"
        height="96"
        class="h-20 w-auto sm:h-24"
      />
    </div>

    <section
      aria-labelledby="page-title"
      class="mt-16 w-full sm:mt-20 md:mt-24"
    >
      <h1
        id="page-title"
        class="mx-auto max-w-4xl text-2xl font-light
               leading-tight sm:text-3xl md:text-[38px] md:leading-[1.25]"
      >
        To HelloMD patients registered with {partnerName} as their licensed producer,
      </h1>

      <div
        class="mx-auto mt-7 max-w-4xl space-y-5
               text-lg font-light leading-relaxed sm:text-2xl"
      >
        <p>HelloMD is open and continuing to serve patients.</p>
        <p>
          At this time, we are not providing administrative services to
          facilitate expedited approvals for <strong class="font-bold"
            >{partnerName}.</strong
          >
        </p>

        <p>
          We understand that this is outside of your control and apologize for
          any inconvenience. This
          <strong class="font-bold">does not</strong>
          relate to your eligibility for medical cannabis or to your individual care.
        </p>

        <p>To discuss your options, please contact us at:</p>
      </div>

      <address
        class="mt-7 space-y-1 not-italic text-lg leading-relaxed
               sm:text-2xl"
      >
        <p>
          <strong class="font-bold">Phone:</strong>
          <a
            href="tel:+18668887013"
            class="rounded-sm hover:underline
                   focus-visible:outline focus-visible:outline-2
                   focus-visible:outline-offset-4"
          >
            1-866-888-7013
          </a>
        </p>

        <p>
          <strong class="font-bold">Fax:</strong>
          <span>1-833-254-1980</span>
        </p>

        <p>
          <strong class="font-bold">Email:</strong>
          <a
            href="mailto:support@hellomd.com"
            class="text-sky-400 underline underline-offset-2
                   hover:text-sky-300
                   focus-visible:outline focus-visible:outline-2
                   focus-visible:outline-offset-4"
          >
            support@hellomd.com
          </a>
        </p>
      </address>

      <p
        class="mx-auto mt-7 max-w-3xl text-lg font-light
               leading-relaxed sm:text-2xl"
      >
        We are open
        <strong class="font-bold">
          Mondays to Fridays, 9 AM to 8 PM ET.
        </strong>
      </p>
    </section>
  </main>
</div>
